import config from '../../config'
import { HttpError } from '../tehtava-api/utils'

export type Crop = {
  aspect: number
  coordinates: {
    x: number
    y: number
    width: number
    height: number
  }
  name: string
}

export type ImsData = {
  crops: Crop[]
  public_id: string
  version: string
}

export const fetchImsData = async (imageId: string): Promise<ImsData> => {
  const { imagesApiUrl, imagesApiAppId, imagesApiAppKey } = config

  const imsDataUrl = `${imagesApiUrl}/presentation_data/${imageId}.json?app_id=${imagesApiAppId}&app_key=${imagesApiAppKey}`

  const response = await fetch(imsDataUrl)
  if (response.status >= 400) {
    throw new HttpError(`Failed to fetch IMS data for id ${imageId}`, response.status)
  }
  return await response.json()
}
